import React, { useEffect, useState } from "react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import video from "../../Background-Video/NUST Campus.mp4";
import youtube_links from "../../APIs/youtube.txt"

const Slider = () => {
    const [currentVideoIndex, setCurrentVideoIndex] = useState(0);
    const [videos, setVideos] = useState([]);
    const [sliderImage, setSliderImage] = useState('');

    useEffect(() => {
        fetchSliderImage();
    }, []);
    useEffect(() => {
        fetch('https://collaboratenust.pythonanywhere.com/youtube-links')
            .then((response) => {
                if (!response.ok) {
                    throw new Error('Failed to fetch data');
                }
                return response.json();
            })
            .then((data) => {
                let links = data?.data?.split("\n");
                links = links.map((link) => link + "&autoplay=1&mute=1&loop=1");
                setVideos(links);
            })
            .catch((error) => {
                console.error('Error fetching data:', error);
            });
    }, []);
    useEffect(() => {
        setVideos(videos.sort(() => Math.random() - 0.5));
    }, [videos])
    useEffect(() => {
        let player;
        try {
            if (video.length > 0) {
                player = new window.YT.Player('player', {
                    height: '100%',
                    width: '100%',
                    videoId: getVideoId(videos[currentVideoIndex]),
                    playerVars: {
                        autoplay: 1,
                        mute: 1,
                        loop: 1,
                        controls: 1,
                    },
                    events: {
                        'onReady': onPlayerReady,
                        'onStateChange': onPlayerStateChange
                    }
                });
            }
        } catch (error) {
            console.error('Error initializing YouTube player:', error);
            // Handle the error gracefully, such as displaying a user-friendly message or fallback content.
        }
        function onPlayerReady(event) {
            event.target.playVideo();
        }

        function onPlayerStateChange(event) {
            if (event.data === window.YT.PlayerState.ENDED) {
                // Video ended, play the next video
                const nextIndex = (currentVideoIndex + 1) % videos.length;
                setCurrentVideoIndex(nextIndex);
                player?.loadVideoById(getVideoId(videos[nextIndex]));
            }
        }
        return () => {
            player?.destroy();
        };
    }, [currentVideoIndex, videos]);
    // Helper function to extract video ID from the embed URL
    function getVideoId(embedUrl) {
        const match = embedUrl.match(/embed\/([^?]+)/);
        return match ? match[1] : '';
    }
    async function fetchSliderImage() {
        try {
            const response = await fetch('https://collaboratenust.pythonanywhere.com/slider');
            if (!response.ok) {
                throw new Error('Failed to fetch slider image');
            }
            const data = await response.blob();
            const imageObjectURL = URL.createObjectURL(data);
            setSliderImage(imageObjectURL);
        } catch (error) {
            console.error('Error fetching slider image:', error);
        }
    }
    return (
        <>
            <div>
                <div className="row-slider">
                    <div style={{ padding: 0 }} className="child-slider">
                        <img style={{ width: "100%" }} src={sliderImage} alt="NUST" className="img-fluid" />
                    </div>
                    <div style={{ padding: 0 }} className="child-slider">
                        <div id="player"></div>
                    </div>
                </div>
            </div>
        </>
    );
}
export default Slider